import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Button, Flex, IconButton, Select, Text } from '@radix-ui/themes';
import { FormField, MultiSelect } from 'shared/components';
import {  JobCategoriesGroupStore } from './job-categories-group.view-model';
import { useTranslation } from 'react-i18next';
import { AddIcon, ClearIcon } from 'shared/icons';
import { JobCategory } from 'jobs/types';

function JobCategoriesGroupView({ viewModel }: { viewModel:  JobCategoriesGroupStore }) {
   const { t } = useTranslation('global');
   return (
      <Flex className="categories-group" direction="column" gap="3">
         {viewModel.categoriesGroup.map((catControl, idx) => {
            return (
               <Box className="category-control" key={catControl.id} pr={idx > 0 ? '100px' : '0'}>
                  <Flex direction="column" align="baseline" justify="between" gap="3">
                     <Flex
                        className="categories-action"
                        width="100%"
                        align={viewModel.categoryControls[idx].error ? 'center' : 'end'}
                        gap="4"
                     >
                        <FormField
                           label="Категорія"
                           required={idx === 0}
                           error={t(viewModel.categoryControls[idx].error)}
                        >
                           <Select.Root
                              size="3"
                              value={catControl.category}
                              onValueChange={(cat) => viewModel.onCategoryChange(idx, cat)}
                           >
                              <Select.Trigger placeholder="Виберіть категорію роботи"></Select.Trigger>
                              <Select.Content
                                 color="blue"
                                 position="popper"
                                 onCloseAutoFocus={(e) => e.preventDefault()}
                              >
                                 <Box maxHeight="250px">
                                    {viewModel.categories.map((cat) => {
                                       return (
                                          <Select.Item key={cat.id} value={cat.id.toString()}>
                                             {cat.name}
                                          </Select.Item>
                                       );
                                    })}
                                 </Box>
                              </Select.Content>
                           </Select.Root>
                        </FormField>

                        {idx === 0 ? (
                           <Button
                              size="3"
                              className="add-messenger-trigger"
                              variant="outline"
                              type="button"
                              onClick={() => viewModel.onAddControl()}
                           >
                              <Text weight="regular" wrap="nowrap">
                                 Додати ще
                              </Text>
                              <AddIcon />
                           </Button>
                        ) : (
                           <IconButton
                              size="3"
                              type="button"
                              variant="outline"
                              onClick={() => viewModel.onRemoveControl(catControl)}
                           >
                              <ClearIcon />
                           </IconButton>
                        )}
                     </Flex>

                     <FormField
                        label="Спеціалізація"
                        required={idx === 0}
                        error={t(viewModel.subCategoryControls[idx].error)}
                     >
                        <MultiSelect.Root
                           vm={catControl.subCategory.multiselect}
                           placeholder="Виберіть спеціалізацію"
                        >
                           {catControl.subCategory.results.map((subCat) => {
                              return (
                                 <MultiSelect.Option<JobCategory>
                                    key={subCat.id}
                                    value={subCat}
                                 >
                                    {subCat.name}
                                 </MultiSelect.Option>
                              );
                           })}
                        </MultiSelect.Root>
                     </FormField>
                  </Flex>
               </Box>
            );
         })}
      </Flex>
   );
}

export const JobCategoriesGroup = observer(JobCategoriesGroupView);
